import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 4.5l6 -1.5l-2 6.5l2 -.5l-4 7v-5l-3 1l1 -7.5","key":"svg-0"}],["path",{"d":"M15 6.5l7 -1.5l-10 17l-10 -17l7.741 1.5","key":"svg-1"}]]

const IconBrandVite = createReactComponent('outline', 'brand-vite', 'BrandVite', __iconNode);

export default IconBrandVite;